import React, { useEffect, useRef, useState } from 'react'
import { ReactEditor } from 'slate-react'
import { Transforms } from 'slate'
import { Popover, TextField } from '@cicero/ui'
import { timer } from 'rxjs'
import { EditorService, IEditorElementProps, IElementDefinition } from '../EditorService'
import { ILinkElement } from '../commands'

export const LinkElement = ({ children, attributes, element }:  IEditorElementProps<ILinkElement>) => {
  const [editing, setEditing] = useState(false)
  const [url, setUrl] = useState(element.url || '')
  const usingEl = useRef<HTMLAnchorElement>(null)
  const service = EditorService.useEditor()
  const selected = EditorService.useSelected()
  const focused = EditorService.useFocused()

  useEffect(() => {
    if (!selected && !focused && editing === true) {
      // setEditing(false)
    } else if (selected && focused && !editing) {
      const sub = timer(600).subscribe(() => {
        setEditing(true)
      })
      return () => sub.unsubscribe()
    }
  }, [selected, focused])

  return <span {...attributes}>
    <a
      href={element.url}
      target="_blank"
      rel="noreferrer"
      ref={usingEl}
    >{children}</a>
    <Popover
      contentEditable={false}
      open={editing}
      anchorEl={usingEl.current}
      onClose={() => setEditing(false)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <form onSubmit={(e) => {
        e.preventDefault()
        setUrl(url || '')
        const path = ReactEditor.findPath(service.editor, element)
        Transforms.setNodes(service.editor, { url }, { at: path })
        setEditing(false)
      }}>
        <TextField
          autoFocus
          placeholder="Add Link URL"
          value={url}
          onChange={(ev: any) => setUrl(ev.target.value)}
        />
      </form>
    </Popover>
  </span>
}

export const LinkElementDef: IElementDefinition = {
  renderer(props) { return <LinkElement {...props} /> },
  setup(service) {
    const { isInline } = service.editor
    service.editor.isInline = (el) => el.type === 'link' ? true : isInline(el)
  },
}
